import { render, staticRenderFns } from "./FarmVehicleTypesView.vue?vue&type=template&id=be00b138&"
import script from "./FarmVehicleTypesView.vue?vue&type=script&lang=ts&"
export * from "./FarmVehicleTypesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports